<div class="asap-users-avatar-icon">
    <img [src]="icon" onerror="this.src='/assets/menu/enterprise/profile-icon.svg'"/>
</div>

<div class="asap-users-avatar-text">
    {{firstName}} {{lastName}}
</div>
